(function(){
  function thumbs(root){return Array.prototype.slice.call(root.querySelectorAll('product-info media-gallery .swiper-controls__thumbnail'))}
  function setActive(comp,index){
    thumbs(comp).forEach(function(b){
      var on=parseInt(b.getAttribute('data-index')||'0',10)===index;
      b.classList.toggle('active',on);
      if(on)b.setAttribute('aria-selected','true');else b.removeAttribute('aria-selected');
    });
  }
  function getSwiper(comp){return comp&&comp.initSwiper?comp.initSwiper:null}
  function slide(comp,index){
    var tries=0;
    (function run(){
      var sw=getSwiper(comp);
      if(sw){
        if(sw.params&&sw.params.loop&&typeof sw.slideToLoop==='function')sw.slideToLoop(index,400);
        else if(typeof sw.slideTo==='function')sw.slideTo(index,400);
        setActive(comp,index);
        return;
      }
      if(++tries<20)setTimeout(run,100);
    })();
  }
  function bind(){
    document.querySelectorAll('product-info media-gallery swiper-component').forEach(function(comp){
      if(comp.__nyThumbWatch)return;
      comp.__nyThumbWatch=true;
      var wait=0;
      (function ready(){
        var sw=getSwiper(comp);
        if(sw&&sw.on){
          sw.on('slideChange',function(){setActive(comp,sw.realIndex||0)});
          setActive(comp,sw.realIndex||0);
        }else if(++wait<20)setTimeout(ready,100);
      })();
    });
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('product-info media-gallery .swiper-controls__thumbnail');
    if(!btn)return;
    var comp=btn.closest('swiper-component');
    if(!comp)return;
    e.preventDefault();
    e.stopPropagation();
    var index=parseInt(btn.getAttribute('data-index')||'0',10);
    slide(comp,index);
  },true);
  document.addEventListener('DOMContentLoaded',bind);
  document.addEventListener('shopify:section:load',bind);
  setTimeout(bind,600);setTimeout(bind,1500);
})();
